/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateIdTypeRequest } from '../models/create-id-type-request';
import { GenericResponse } from '../models/generic-response';
import { GetIdTypeResponse } from '../models/get-id-type-response';
import { IdTypeResponse } from '../models/id-type-response';
import { UpdateIdTypeRequest } from '../models/update-id-type-request';

/**
 * Id type apis
 */
@Injectable({ providedIn: 'root' })
export class IdTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllIdType()` */
  static readonly GetAllIdTypePath = '/api/v1/id-types';

  /**
   * Get list of id types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllIdType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllIdType$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetIdTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      IdTypeService.GetAllIdTypePath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetIdTypeResponse>;
        })
      );
  }

  /**
   * Get list of id types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllIdType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllIdType(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetIdTypeResponse> {
    return this.getAllIdType$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetIdTypeResponse>): GetIdTypeResponse => r.body
      )
    );
  }

  /** Path part for operation `createIdType()` */
  static readonly CreateIdTypePath = '/api/v1/id-types';

  /**
   * Create new id type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createIdType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createIdType$Response(
    params: {
      body: CreateIdTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<IdTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      IdTypeService.CreateIdTypePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<IdTypeResponse>;
        })
      );
  }

  /**
   * Create new id type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createIdType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createIdType(
    params: {
      body: CreateIdTypeRequest;
    },
    context?: HttpContext
  ): Observable<IdTypeResponse> {
    return this.createIdType$Response(params, context).pipe(
      map((r: StrictHttpResponse<IdTypeResponse>): IdTypeResponse => r.body)
    );
  }

  /** Path part for operation `deleteIdType()` */
  static readonly DeleteIdTypePath = '/api/v1/id-types/{id}';

  /**
   * Delete passenger type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteIdType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteIdType$Response(
    params: {
      /**
       * The passenger type's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      IdTypeService.DeleteIdTypePath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete passenger type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteIdType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteIdType(
    params: {
      /**
       * The passenger type's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteIdType$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateIdType()` */
  static readonly UpdateIdTypePath = '/api/v1/id-types/{id}';

  /**
   * Update id type by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateIdType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateIdType$Response(
    params: {
      /**
       * The id type's id that needs to be updated
       */
      id: number;
      body: UpdateIdTypeRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<IdTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      IdTypeService.UpdateIdTypePath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<IdTypeResponse>;
        })
      );
  }

  /**
   * Update id type by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateIdType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateIdType(
    params: {
      /**
       * The id type's id that needs to be updated
       */
      id: number;
      body: UpdateIdTypeRequest;
    },
    context?: HttpContext
  ): Observable<IdTypeResponse> {
    return this.updateIdType$Response(params, context).pipe(
      map((r: StrictHttpResponse<IdTypeResponse>): IdTypeResponse => r.body)
    );
  }
}
